import { getApp, AppName } from '@mx/util/get-app'
import { getSystem, System } from '@mx/util/get-system'
import { getQueryString } from '@mx/util/get-query-string'

type NodeEnv = 'development' | 'test' | 'staging' | 'production'
class Env {
  system: System
  appName: AppName
  env: NodeEnv
  utmSource: string
  isMock: boolean
  isWeiXin: boolean
  isTitans: boolean
  // 业务参数
  pageStyle: string
  bankTypeIds?: number[]
  campaignId?: number
  closekey?: string
  rewardType?: string
  ruleContext?: RuleContext | null

  constructor() {
    this.system = getSystem()
    this.appName = getApp()
    this.env = import.meta.env.VITE_NODE_ENV as NodeEnv
    this.utmSource = getQueryString('utm_source') || '-999'
    this.isMock = !!getQueryString('isMock')
    this.isWeiXin = !!(this.appName === 'weixin')
    this.isTitans = KNB.env.isTitans
    this.pageStyle = getQueryString('page_style') || 'default'
    const bankTypeIds = getQueryString('bank_type_ids')
    this.bankTypeIds = bankTypeIds
      ? bankTypeIds
          .split(',')
          .filter(Boolean)
          .map((i) => +i)
      : undefined
    this.campaignId = +getQueryString('campaign_id')
    this.closekey = getQueryString('closekey') || ''
    this.rewardType = getQueryString('reward_type') || ''
    try {
      this.ruleContext = JSON.parse(getQueryString('rule_context'))
    } catch (err) {
      this.ruleContext = null
    }
  }
}

export const env = new Env()
export default env
